export default {
  columnFileName: 'File Name',
  columnImageVideo: 'Image/Video',
  columnFileSize: 'File Size',
  columnUploadTime: 'Upload Time',
  columnAction: 'Action',

  statusCompleted: 'Completed',
  statusInProgress: 'In Progress',
  statusUnknown: 'Unknown',

  download: 'Download',
  noValue: '--',
  sizeMb: '{value} MB',
}
